module.exports = __webpack_public_path__ + "images/emoji/floppy_disk.5f9c379c5d56c4bd21b3.png";